import { render, staticRenderFns } from "./customer_add.vue?vue&type=template&id=d3918f3a&"
import script from "./customer_add.vue?vue&type=script&lang=js&"
export * from "./customer_add.vue?vue&type=script&lang=js&"
import style0 from "./customer_add.vue?vue&type=style&index=0&id=d3918f3a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports